<template>
  <div class="shipment-data">
    <div class="switch-menu">
      <el-radio-group
        class="menu-name"
        v-for="(item, index) in menuList"
        :key="index"
        v-model="selectedTab"
        @change="toUrl(item.url)"
      >
        <el-radio-button :label="item.name"></el-radio-button>
      </el-radio-group>
    </div>
    <div class="search-container">
      <div class="statistics">
        <div
          v-for="(item,index) in statisticsList"
          :key="index"
          class="item-statistics border-right"
          :class="(index+1) > 4? 'border-top':''"
        >
          <img class="statistics-img" :src="item.img" alt>
          <div>
            <p class="sub-title">{{item.title}}</p>
            <p class="sub-content">{{item.content}}</p>
          </div>
        </div>
      </div>
      <div class="search">
        <div class="search-left">
          <el-select
            v-model="warehouseId"
            clearable
            class="gray"
            placeholder="请选择仓库"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-date-picker
            class="gray marginRight"
            v-model="date"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            placeholder="选择日期">
          </el-date-picker>
          <el-button class="btn-white" @click="clearData">重置</el-button>
          <el-button class="btn-blue" @click="searchData">搜索</el-button>
        </div>
        <div class="search-left">
          <el-button class="btn-white" @click="openActualOrderNums"
            >实际单量设置</el-button
          >
        </div>
      </div>
    </div>
    <div class="table shipment-table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
        ></el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>

    <!-- 实际单量设置 -->
    <el-dialog
      title="实际单量设置"
      top="15vh"
      :visible.sync="dialog"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="search">
        <div class="search-left">
          <el-select
            v-model="actualWarehouseId"
            clearable
            class="gray"
            placeholder="请选择仓库"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-date-picker
            class="gray marginRight"
            v-model="actualDate"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            placeholder="选择日期">
          </el-date-picker>
          <el-button class="btn-blue" @click="searchActualData">搜索</el-button>
        </div>
      </div>
      <div class="table">
        <el-table :data="tableActualList" style="width: 100%;">
          <el-table-column
            prop="projectName"
            label="项目名称"
          ></el-table-column>
          <el-table-column prop="actualOrderNums" label="实际单量">
            <template slot-scope="scope">
              <el-input
                class="white"
                v-model="scope.row.actualOrderNums"
                @input="inputActualOrderNums(scope.$index, scope.row.actualOrderNums)"
                @blur="blurActualOrderNums(scope.row.id, scope.row.actualOrderNums)"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getInteger, formatTimeToDate } from "common/js/util";
import PaginationTpl from "components/base/PaginationTpl";
import ShipmentData from "models/shipment-data";
import Expenses from "models/expenses";
const expenses = new Expenses();
export default {
  components: {
    PaginationTpl,
  },

  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '项目名称', prop: 'projectName', width: ''},
        {label: '截单时间', prop: 'cutOffTime', width: ''},
        {label: '实际单量', prop: 'actualOrderNums', width: ''},
        {label: '完成订单数', prop: 'finishOrderNums', width: ''},
        {label: '未完成订单数', prop: 'incompleteOrderNums', width: ''},
        {label: '完成率', prop: 'completionRate', width: ''},
        {label: '完成总件数', prop: 'finishTotalNums', width: ''},
        {label: '客单件均数', prop: 'singlePiece', width: ''},
        {label: '同品订单数', prop: 'homologueOrderNums', width: ''},
        {label: '同品件数', prop: 'homologueNums', width: ''},
      ],
      date: formatTimeToDate(new Date().getTime() - 60*60*24*1000),
      warehouseId: '',
      warehouseList: [],
      statisticsList: [
        {title: '订单总数', content: 0, img: require('../../../../../assets/images/shipment-data/total-order-num.png')},
        {title: '完成订单数', content: 0, img: require('../../../../../assets/images/shipment-data/finish-order-num.png')},
        {title: '未完成订单数', content: 0, img: require('../../../../../assets/images/shipment-data/incomplete-order-num.png')},
        {title: '完成率', content: '0%', img: require('../../../../../assets/images/shipment-data/completion-rate.png')},
        {title: '完成总件数', content: 0, img: require('../../../../../assets/images/shipment-data/finish-total-num.png')},
        {title: '客单件均数', content: 0, img: require('../../../../../assets/images/shipment-data/single-piece.png')},
        {title: '同品订单数', content: 0, img: require('../../../../../assets/images/shipment-data/homologue-order-num.png')},
        {title: '同品件数', content: 0, img: require('../../../../../assets/images/shipment-data/homologue-num.png')},
      ],
      dialog: false,
      tableActualList: [],
      actualWarehouseId: '',
      actualDate: formatTimeToDate(new Date().getTime() - 60*60*24*1000),
      
      menuList: [
        {name: '发货数据', url: '/home/production-data/shipment-data'},
        {name: '售后数据', url: '/home/production-data/after-sale'}
      ],
      selectedTab: '发货数据'
    };
  },

  async created() {
    await this.getWarehouse()
    this.initShipmentDataList();
    this.initShipmentStatisticsListList();
  },

  methods: {
    //获取仓库数据
    async getWarehouse() {
      let res = await expenses.getWarehouseData()
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
          this.warehouseId = arr.length > 0 ? arr[0].id : '';
          this.actualWarehouseId = arr.length > 0 ? arr[0].id : '';
        }
    },

    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initShipmentDataList();
    },

    /* 仓库总计 */
    initShipmentStatisticsListList() {
      let date = this.date
      let warehouseId = this.warehouseId
      let data = {
        date,
        warehouseId
      }
      ShipmentData.getShipmentStatisticsListList(data).then(res => {
        if (res.success) {
          let { receiveOrderNum, finishOrderNum, notFinishOrderNum, finishRate, finishGoodsNum,
          finishGoodsNumByUnitOrderNum, hotOrderNum, hotGoodsNum } = res.result
          let completionRate = finishRate == '-' ? finishRate: `${finishRate}%`
          this.statisticsList = [
            {title: '订单总数', content: receiveOrderNum, img: require('../../../../../assets/images/shipment-data/total-order-num.png')},
            {title: '完成订单数', content: finishOrderNum, img: require('../../../../../assets/images/shipment-data/finish-order-num.png')},
            {title: '未完成订单数', content: notFinishOrderNum, img: require('../../../../../assets/images/shipment-data/incomplete-order-num.png')},
            {title: '完成率', content: completionRate, img: require('../../../../../assets/images/shipment-data/completion-rate.png')},
            {title: '完成总件数', content: finishGoodsNum, img: require('../../../../../assets/images/shipment-data/finish-total-num.png')},
            {title: '客单件均数', content: finishGoodsNumByUnitOrderNum, img: require('../../../../../assets/images/shipment-data/single-piece.png')},
            {title: '同品订单数', content: hotOrderNum, img: require('../../../../../assets/images/shipment-data/homologue-order-num.png')},
            {title: '同品件数', content: hotGoodsNum, img: require('../../../../../assets/images/shipment-data/homologue-num.png')},
          ]
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /* 发货数据列表 */
    initShipmentDataList() {
      let date = this.date
      let warehouseId = this.warehouseId
      let currentPage = this.currentPage
      let data = {
        date,
        currentPage,
        warehouseId
      }
      ShipmentData.getShipmentDataList(data).then(res => {
        if (res.success) {
          let arr = []
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(i => {
            let obj = {}
            obj.projectId = i.projectId
            obj.projectName = i.projectName
            obj.cutOffTime = i.finalOrderTime?i.finalOrderTime:0
            obj.actualOrderNums = i.receiveOrderNum
            obj.finishOrderNums = i.finishOrderNum
            obj.incompleteOrderNums = i.notFinishOrderNum
            obj.completionRate = i.finishRate === '-'?i.finishRate:`${i.finishRate}%`
            obj.finishTotalNums = i.finishGoodsNum
            obj.singlePiece = i.finishGoodsNumByUnitOrderNum
            obj.homologueOrderNums = i.hotOrderNum
            obj.homologueNums = i.hotGoodsNum
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /* 实际单量设置 */
    initActualList() {
      let date = this.actualDate
      let warehouseId = this.actualWarehouseId
      let data = {
        date,
        warehouseId
      }
      ShipmentData.getActualList(data).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.projectId
            obj.projectName = i.projectName
            obj.actualOrderNums = i.receiveOrderNum
            arr.push(obj)
          })
          this.tableActualList = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    clearData() {
      this.date = "";
      this.warehouseId = "";
    },

    searchData() {
      if (!this.warehouseId) return this.$message.error('请选择仓库')
      if (!this.date) return this.$message.error('请选择日期')
      this.currentPage = 1;
      this.initShipmentDataList();
      this.initShipmentStatisticsListList();
    },

    async openActualOrderNums() {
      this.actualWarehouseId = await this.warehouseList.length > 0 ? this.warehouseList[0].id : '';
      this.actualDate = await formatTimeToDate(new Date().getTime() - 60*60*24*1000)
      await this.initActualList()
      this.dialog = true
    },

    searchActualData() {
      this.initActualList();
    },

    closeDialog() {
      this.actualDate = "";
      this.actualWarehouseId = "";
      this.dialog = false
      this.initShipmentDataList();
      this.initShipmentStatisticsListList();
    },

    confirm() {
      this.closeDialog()
    },
    
    inputActualOrderNums(index, price) {
      let actualOrderNums = getInteger(price);
      this.tableActualList[index].actualOrderNums = actualOrderNums;
    },

    blurActualOrderNums(projectId, receiveOrderNum) {
      let date = this.actualDate
      let data = {
        date,
        projectId,
        receiveOrderNum
      }
      ShipmentData.saveActualOrderNums(data).then(res => {
        if (!res.success) {
          this.$message.error(res.message)
        }
      })
    },

    toUrl(v) {
      this.$router.push({
        path: v,
      });
    }
  },
};
</script>

<style lang='scss' scoped>
.shipment-data {
  flex: 1;
  .search-container {
    background: #fff;
    border-radius: 4px;
    padding:0px 20px 16px 20px;
    margin-bottom: 16px;
    .statistics {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      border-bottom: 1px solid #eee;
      margin-bottom: 16px;
      .border-top {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          left: 50%;
          transform: translate(-50%);
          top: 0px;
          height: 1px;
          width: 90%;
          background-color: #eee;
        }
      }
      .border-right {
        position: relative;
        &::before {
          content: '';
          position: absolute;
          left: 0%;
          top: 50%;
          transform: translateY(-50%);
          height: 66px;
          width: 1px;
          background-color: #eee;
        }
      }
      .item-statistics {
        width: 25%;
        height: 106px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding-left: 41px;
        .statistics-img {
          width: 56px;
          height: 56px;
          margin-right: 21px;
        }
        .sub-title {
          font-size: 14px;
          font-weight: 400;
          color: #999999;
        }
        .sub-content {
          margin-top: 14px;
          font-size: 24px;
          font-weight: 400;
          color: #333333;
        }
      }
      .item-statistics:nth-child(1),
      .item-statistics:nth-child(5) {
        padding-left: 0px;
      }
      .border-right:nth-child(1),
      .border-right:nth-child(5) {
        &::before {
          display: none;
          width: 0;
          height: 0;
        }
      }
      .border-top:nth-child(1),
      .border-top:nth-child(5) {
        &::after {
          left: 0%;
          width: 95.2%;
          transform: translate(0%);
        }
      }
    }
  }
  .search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-select {
      margin-right: 16px;
    }
    .el-input {
      width: 200px;
    }
    .btn-blue {
      margin-left: 16px;
    }
    .marginRight {
      margin-right: 16px;
    }
  }
  .shipment-table {
    min-height: 470px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
<style lang="scss">
.shipment-data {
  .switch-menu {
    height: 56px;
    border-radius: 8px;
    background: #fff;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    padding: 0px 20px;
    .menu-name {
      height: 56px;
      line-height: 56px;
      margin-right: 32px;
      .el-radio-button__inner {
        font-size: 16px;
        font-weight: bold;
        border: none;
        color: #666666;
        background: transparent;
        padding: 0;
      }
      .is-active {
        border-bottom: 2px solid #2E68EA;
        .el-radio-button__inner {
          color: #2E68EA;
        }
      }
    }
  }
  .el-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 16px;
    }
    .el-dialog__body {
      .search {
        margin-bottom: 16px;
      }
      .table {
        .el-table {
          .el-table__body-wrapper {
            height: 297px;
            overflow-y: auto;
          }
          .el-input {
            width: 160px;
            .el-input__inner {
              height: 24px;
              width: 160px;
              padding-left: 10px;
            }
          }
        }
      }
    }
    .el-dialog__footer {
      padding: 0px;
      .dialog-footer {
        border-top: 1px solid #eee;
        padding-top: 16px;
        padding-bottom: 16px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
